import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DesktopFooter = () => {
  const { t } = useTranslation('landingPage');

  return (
    <footer className="bg-black/80 backdrop-blur-sm text-white py-3 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4 text-sm">
            <span className="text-gray-400">{t('footer.copyright')}</span>
            <Link
              to="/privacy-policy"
              className="text-purple-300 hover:text-purple-200 transition-colors underline underline-offset-2"
            >
              PRIVACY POLICY
            </Link>
            <Link
              to="/terms-of-service"
              className="text-purple-300 hover:text-purple-200 transition-colors underline underline-offset-2"
            >
              TERMS OF SERVICE
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <img
              src="/image/logo/gg01.png"
              alt="GG Logo"
              className="h-8 object-contain"
            />
            <img
              src="/image/logo/bbtcoin_newlogo.png"
              alt="BBT Logo"
              className="h-10 object-contain"
            />
            <img
              src="/image/logo/worldcoin_white.png"
              alt="Worldcoin Logo"
              className="h-7 object-contain"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DesktopFooter;
